import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";
import {
  useDictationAnywhereStore,
  type DictationAnywhereState,
} from "./dictation-anywhere/dictation-anywhere-store";

type State = {
  suppressed: boolean;
  setSuppressed: (suppressed: boolean) => void;
};

export const useVoiceIndicatorVisibility = create<State>()(
  mirroredStore("voice-indicator-visibility", (set) => ({
    suppressed: false,
    setSuppressed: (suppressed) => set({ suppressed }),
  })),
);

export function setVoiceIndicatorSuppressed(suppressed: boolean) {
  useVoiceIndicatorVisibility.getState().setSuppressed(suppressed);
}

/** Dictation anywhere shows its own indicator at the pointer from the
 *  trigger until its result retracts. A refusal ("not available") leaves the
 *  voice input that caused it on show. */
function dictationAnywhereOwnsVoiceFeedback({
  phase,
  reason,
}: DictationAnywhereState): boolean {
  return (
    phase !== "idle" && !(phase === "failed" && reason === "not_available")
  );
}

/** Whether the Denker voice indicator and listening surface stay hidden: a
 *  focused target owns the dictation, or dictation anywhere is running. */
export function useVoiceIndicatorHidden(): boolean {
  const suppressed = useVoiceIndicatorVisibility((state) => state.suppressed);
  const anywhere = useDictationAnywhereStore(
    dictationAnywhereOwnsVoiceFeedback,
  );
  return suppressed || anywhere;
}
